import { Controller } from "stimulus";

export default class extends Controller {

  static get targets() {
    return [
      ''
    ];
  }

  initialize() {
    this.translateClassName = '[&:not(.is-open)]:-translate-y-full';
    this.watchHeight();
    this.watchScroll();

    this.onHeightChange(this.element);
    this.onScroll();
  }

  watchHeight() {
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.onHeightChange(entry);
      }
    });
    observer.observe(this.element);
  }

  onHeightChange(element) {
    this.headerHeight = Math.ceil(this.element.offsetHeight);
    document.documentElement.style.setProperty('--site-header__height', this.headerHeight + 'px');
  }

  watchScroll() {
    this.lastScrollPosition = 0;
    this.isCheckingScroll = false;

    document.addEventListener("scroll", (event) => {

      if (!this.isCheckingScroll) {
        window.requestAnimationFrame(() => {
          this.onScroll(this.lastScrollPosition);
          this.isCheckingScroll = false;
        });
        this.isCheckingScroll = true;
      }
    }, { passive: true });
  }

  onScroll() {
    this.currentScrollPosition = window.scrollY;
    this.isHeaderInitialPosition = this.currentScrollPosition <= this.headerHeight;

    this.checkInitialPosition();
    this.checkScrollDirection();

    this.lastScrollPosition = this.currentScrollPosition;
  }

  checkInitialPosition() {
    if (this.isHeaderInitialPosition) {
      this.element.classList.remove(this.translateClassName);
      this.element.style.removeProperty('--site-header__opacity-override');
    }
    else {
      this.element.style.setProperty('--site-header__opacity-override', 1);
    }
  }

  checkScrollDirection() {
    if (!this.isHeaderInitialPosition && this.currentScrollPosition > this.lastScrollPosition) {
      this.element.classList.add(this.translateClassName);
    }
    else {
      this.element.classList.remove(this.translateClassName);
    }
  }
}